// The web's copy of the job ladder's one rule it needs (round 45): which
// statuses are CLOSED. The server's src/lib/jobStatus.ts is the source; this
// mirrors its CLOSED_STATUSES so the Edit button and the server's refusal
// agree (invoiced was missing here, so an invoiced job offered an Edit the
// server then refused). On hold is OPEN on both sides.
import type { JobStatus } from '../schedulingApi';

export const CLOSED_STATUSES: readonly JobStatus[] = ['completed', 'invoiced', 'cancelled'];
